// import React from "react";
// import StatCard from "./StatCard"; // ✅ First card (Image)
// import StatCardTwo from "./StatCardTwo";
// import StatCardThree from "./StatCardThree";
// import StatCardFour from "./StatCardFour";
// import StatCardFive from "./StatCardFive";
// import "../styles/StatsSection.css";

// const StatsSection = () => {
//   return (
//     <div className="stats-frame">
//       <div className="stats-container">
//         {/* ✅ Wrap ALL Cards Inside stats-subframe */}
//         <div className="stats-subframe">
//           <StatCard /> {/* ✅ First Card - Now Inside Correct Wrapper */}
          
//           {/* ✅ Frame for Three Cards */}
//           <div className="stats-mini-frame">
//             <StatCardTwo />
//             <StatCardThree />
//             <StatCardFour />
//           </div>

//           <StatCardFive />
//         </div>
//       </div>
//     </div>
//   );
// };

// export default StatsSection;


// import React from "react";
// import StatCard from "./StatCard"; // ✅ First card (Image)
// import StatCardTwo from "./StatCardTwo";
// import StatCardThree from "./StatCardThree";
// import StatCardFour from "./StatCardFour";
// import StatCardFive from "./StatCardFive";
// import "../styles/StatsSection.css";

// const StatsSection = () => {
//   return (
//     <div className="stats-frame">
//       <div className="stats-container">
//         <div className="stats-subframe">
//           {/* ✅ First Card */}
//           <StatCard />

//           {/* ✅ Middle Cards with scroll wrapper */}
//           <div className="stats-mini-frame">
//             <div className="stats-scroll">
//               {/* Original set */}
//               <StatCardTwo />
//               <StatCardThree />
//               <StatCardFour />

//               {/* Duplicate set for seamless loop (mobile only) */}
//               <StatCardTwo />
//               <StatCardThree />
//               <StatCardFour />
//             </div>
//           </div>

//           {/* ✅ Last Card */}
//           <StatCardFive />
//         </div>
//       </div>
//     </div>
//   );
// };

// export default StatsSection;



import React from "react";
import StatCard from "./StatCard"; // ✅ First card (Image)
import StatCardTwo from "./StatCardTwo";
import StatCardThree from "./StatCardThree";
import StatCardFour from "./StatCardFour";
import StatCardFive from "./StatCardFive";
import "../styles/StatsSection.css";

const StatsSection = () => {
  return (
    <div className="stats-frame">
      <div className="stats-container">
        <div className="stats-subframe">
          {/* ✅ First Card */}
          <StatCard />

          {/* ✅ Middle Cards */}
          <div className="stats-mini-frame">
            {/* Normal set (always visible) */}
            <div className="stats-scroll">
              <StatCardTwo />
              <StatCardThree />
              <StatCardFour />
            </div>

            {/* Duplicate set (mobile only, hidden on desktop) */}
            {/* <div className="stats-scroll mobile-duplicates">
              <StatCardTwo />
              <StatCardThree />
              <StatCardFour />
            </div> */}
          </div>

          {/* ✅ Last Card */}
          <StatCardFive />
        </div>
      </div>
    </div>
  );
};

export default StatsSection;
